// extracted by mini-css-extract-plugin
module.exports = {"userIcon":"UserIcon_userIcon__1q3VA","value":"UserIcon_value__gKEtt"};